import { createTheme, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
  },
  loader: {
    margin: '17px',
    color: '#3C419A',
  },
  text: {
    textAlign: 'center',
    color: '#3C419A',
    fontWeight: 700,
    fontSize: '22px',
    lineHeight: '24px',
  },
}));

export const theme = createTheme({
  overrides: {
    MuiCircularProgress: {
      colorPrimary: {
        color: '#3C419A',
        size: '40000',
      },
    },
    MuiButtonBase: {
      root: {
        disableRipple: true
      }
    },
  },
});
